(function () {
  'use strict';

  const QTY_MIN = 1;
  const QTY_MAX = 10;

  const clamp = (v) => Math.max(QTY_MIN, Math.min(QTY_MAX, v));

  async function applyDiscountCodes(newCodes) {
    try {
      await window.ShopifyConstant.applyCartDiscountCodes(newCodes);
    } catch (error) {
      window.ShopifyConstant.reportCartDiscountError(error);
    }
  }

  function initSpecialOffer(container) {
    const rows = Array.from(container.querySelectorAll('.lepro-so__row'));
    if (!rows.length) return;

    // ── 行选中逻辑 ─────────────────────────────────────────────────────
    const selectRow = (targetRow) => {
      rows.forEach((r) => r.classList.remove('is-selected'));
      targetRow.classList.add('is-selected');
    };

    // ── 每行：选中 + 数量控制 + 加购 ──────────────────────────────────
    rows.forEach((row) => {
      const minusBtn = row.querySelector('.lepro-so__qty-btn--minus');
      const plusBtn  = row.querySelector('.lepro-so__qty-btn--plus');
      const input    = row.querySelector('.lepro-so__qty-input');
      const addBtn   = row.querySelector('.lepro-so__add-btn');

      // 行选中（缺货行不可选）
      row.addEventListener('click', () => {
        if (row.classList.contains('is-sold-out')) return;
        selectRow(row);
      });

      // 数量控制
      const updateBtns = () => {
        const v = parseInt(input.value, 10);
        minusBtn.disabled = v <= QTY_MIN;
        plusBtn.disabled  = v >= QTY_MAX;
      };

      minusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        selectRow(row);
        input.value = clamp(parseInt(input.value, 10) - 1);
        updateBtns();
      });

      plusBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        selectRow(row);
        input.value = clamp(parseInt(input.value, 10) + 1);
        updateBtns();
      });

      input.addEventListener('change', () => {
        input.value = clamp(parseInt(input.value, 10) || QTY_MIN);
        updateBtns();
      });

      updateBtns();

      // 加购
      if (!addBtn) return;

      addBtn.addEventListener('click', async (e) => {
        e.stopPropagation();
        selectRow(row);

        const variantId = parseInt(addBtn.dataset.variantId, 10);
        const qty = parseInt(input.value, 10) || 1;
        if (!variantId) return;

        addBtn.disabled = true;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const sections = cart && typeof cart.getSectionsToRender === 'function'
          ? cart.getSectionsToRender().map((s) => s.id)
          : [];

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: qty }],
              sections,
              sections_url: window.location.pathname
            })
          });
          if (!res.ok) throw new Error('Cart error');
          const data = await res.json();

          await applyDiscountCodes([row.dataset.discountCode]);

          if (cart && typeof cart.renderContents === 'function') cart.renderContents(data);
        } catch (err) {
          console.error('[lepro-special-offer] Add to cart failed:', err);
        } finally {
          addBtn.disabled = false;
        }
      });
    });
  }

  // ── 初始化（兼容 Shopify Section Rendering API）──────────────────────
  function init() {
    document.querySelectorAll('.lepro-so').forEach((container) => {
      if (!container.dataset.soInit) {
        container.dataset.soInit = '1';
        initSpecialOffer(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
